import Layout from "../components/Layout";



function SubsidariesContent(){
    return <div>
        <h1>Subsidaries</h1>

    </div>;
}

export default function Subsidaries(){
    return <Layout>
      <SubsidariesContent></SubsidariesContent>
    </Layout>
}